import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AutoComplete, Input } from "antd";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { VaporAccordion } from "../../../../vapor";
import VaporChip from "../../../../vapor/chip";
import Table from "../../../../vapor/tableComplex";
import { VaporDatePicker } from "../../../../vapor";
import { useIntl } from "react-intl";

const Search = Input.Search;

const UsedGoodsSearch = ({ businessId, setGoodsSearched }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [accordion, setAccordion] = useState([true, true]); // Status of accordion (Open/Close)
  const [usedGoodsList, setUsedGoodsList] = useState([]);
  const [filters, setFilters] = useState({
    dateFrom: null,
    dateTo: null,
    supplier: "",
    description: ""
  });
  const [showFilters, setShowFilters] = useState(false); // Show/Hide filters chips section
  const [visibleFilters, setVisibleFilters] = useState(null); // Save here filters value visible in chips
  const [cancelSearch, setCancelSearch] = useState(false); // Set if show "search" icon or "x" icon in the top input field
  const [autocompleteList, setAutocompleteList] = useState([]); // Autocomplete list
  const [delayAutocomplete, setDelayAutocomplete] = useState(null); // Delay autocomplete
  const [selectPressed, setSelectPressed] = useState(false); // Set if an option is clicked in the autocomplete list
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  // Columns for table header
  const columns = [
    {
      dataIndex: "radiobutton",
      key: "radiobutton",
      title: ""
    },
    {
      dataIndex: "supplier",
      key: "supplier",
      title: intl.formatMessage({id: "precog.usedGoods.supplier"})
    },
    {
      dataIndex: "description",
      key: "description",
      title: intl.formatMessage({id: "precog.usedGoods.description"})
    },
    {
      dataIndex: "alias",
      key: "alias",
      title: intl.formatMessage({id: "precog.usedGoods.idCode"})
    },
    {
      dataIndex: "purchaseDate",
      key: "purchaseDate",
      title: intl.formatMessage({id: "precog.usedGoods.buyDate"})
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: intl.formatMessage({id: "precog.usedGoods.total"})
    }
  ];

  const resetDate = () => {
    setFilters({
      ...filters,
      dateFrom: null,
      dateTo: null
    });
  };

  const clearFilters = (asset) => {
    setFilters({
      dateFrom: null,
      dateTo: null,
      supplier: "",
      description: asset
    });
  };

  /**
     * Function to get assets list based on filters, if newFilters are not passed use global filters
     * @param {*} newFilters
     */
  const handleSearch = (newFilters = null) => {
    let filtersUsed = newFilters ? newFilters : filters;
    if (filtersUsed.description !== "")
      setCancelSearch(true);
    else
      setCancelSearch(false);
    if (filtersUsed.dateFrom || filtersUsed.dateTo || filtersUsed.supplier || filtersUsed.description) {
      setVisibleFilters(filtersUsed);

      let dataToDispatch = {
        ...filtersUsed
      };
      if (filtersUsed.dateFrom && filtersUsed.dateTo)
        dataToDispatch = {
          ...filtersUsed,
          purchaseDateFrom: filtersUsed.dateFrom ? filtersUsed.dateFrom.format("YYYY-MM-DD") : null,
          purchaseDateTo: filtersUsed.dateTo ? filtersUsed.dateTo.format("YYYY-MM-DD") : null
        };
      
      dispatch(getFixedAssetsList(businessId, dataToDispatch))
        .then(res => {
          const isFiltersVisible = Object.keys(filtersUsed).length > 0 && ((filtersUsed.dateFrom && filtersUsed.dateTo) || filtersUsed.supplier);
          setShowFilters(isFiltersVisible);
          setUsedGoodsList(res.elements);
          setAccordion([false, false]);
        });
    } else {
      clearFilters(filters.description);
      setShowFilters(false);
      setUsedGoodsList([]);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setGoodsSearched(selectedRows[0]);
    }
  };

  /**
     * Function to render chips with filters values and "Annula filtri" button     
     */
  const renderFilters = () => {
    if (showFilters)
      return <div className="drawer-search-filters-chips">
        <span className="drawer-search-filters-cancel" onClick={() => {
          handleSearch({ description: filters.description });
        }}>Annulla filtri</span>
        {visibleFilters.supplier && <VaporChip
          onClick={() => {
            setFilters("supplier", "");
            setVisibleFilters({ ...visibleFilters, supplier: "" });
            handleSearch({ ...visibleFilters, supplier: "" });
          }}
          title={
            <>
              <span className="light">Fornitore</span>
              {visibleFilters.supplier}
              <span className="icon"></span>
            </>
          }
          active={true}
          style={{
            borderRadius: "0px",
            border: "unset",
            fontWeight: "600",
            paddingRight: "35px",
            position: "relative"
          }}
        />}
        {(visibleFilters.dateFrom || visibleFilters.dateTo) &&
          <VaporChip
            onClick={() => {
              resetDate();
              setVisibleFilters({ ...visibleFilters, dateFrom: null, dateTo: null });
              handleSearch({ ...visibleFilters, dateFrom: null, dateTo: null });
            }}
            title={
              <>
                <span className="light">Data</span>
                {`${visibleFilters.dateFrom ? visibleFilters.dateFrom.format("DD/MM/YYYY") : " * "} - ${visibleFilters.dateTo ? visibleFilters.dateTo.format("DD/MM/YYYY") : " * "}`}
                <span className="icon" ></span>
              </>}
            active={true}
            style={{
              borderRadius: "0px",
              border: "unset",
              fontWeight: "600",
              paddingRight: "35px",
              position: "relative"
            }}
          />}

      </div>;

    return undefined;
  };

  const handleAutocomplete = (value) => {

    if (value.length >= 3) {
      if (delayAutocomplete)
        clearTimeout(delayAutocomplete);
      
      setDelayAutocomplete(setTimeout(dispatch(getFixedAssetsList(businessId, {
        description: value
      }))
        .then(res => {
          const newAutocompleteList = res.elements ?
            ([...new Set(res.elements.map(asset => asset.description))]).map(x => { return { value: x, label: x }; })
            : [];
          setAutocompleteList(newAutocompleteList);
        })), 500);
    } else {
      setAutocompleteList([]);
      setDelayAutocomplete(null);
    }
  };

  return (
    <div className="search-goods-drawer-section">
      <div className="drawer-search-header">
        <div className="drawer-search-text">
          <FormattedMessage id={"preCog.usedGoods.searchExistingGoods"} />
        </div>
        <AutoComplete
          className="drawer-search-autocomplete"
          options={autocompleteList}
          value={filters.description}
          open={autocompleteList && autocompleteList.length > 0 && !selectPressed ? true : false}
          onSelect={value => {
            setFilters("description", value);
            setSelectPressed(true);
            setAutocompleteList([]);
          }}
          onFocus={() => {
            setSelectPressed(false);
            setAutocompleteList([]);
          }}
          onChange={(value) => {
            setFilters("description", value);
            handleAutocomplete(value);
            setCancelSearch(false);
            if (value !== filters.description)
              setSelectPressed(false);
          }}
          onBlur={() => {
            setAutocompleteList([]);
            setDelayAutocomplete(null);
          }}
          getPopupContainer={trigger => trigger.parentNode}

        >
          <Search
            size="large"
            enterButton={cancelSearch ? <FontAwesomeIcon icon={["far", "times"]} style={{ width: "14px" }} /> : <FontAwesomeIcon icon={["fal", "search"]} />
            }
            onSearch={() => {
              if (cancelSearch && filters.description) {
                handleSearch({ ...filters, description: "" });
                setVisibleFilters({ ...visibleFilters, description: "" });
                setFilters("description", "");
              } else
                handleSearch();
            }}
          />
        </AutoComplete>
      </div>
      <div className="drawer-search-body">
        <div className="drawer-search-filter-title">
          <FormattedMessage id={"preCog.assetsTab.drawer.filterResults"} />
        </div>
        {renderFilters()}
        <VaporAccordion
          onChange={val => setAccordion([!accordion[0], accordion[1]])}
          opened={accordion[0]}
          title={<FormattedMessage id={"preCog.assetsTab.drawer.date"} />}
        >
          <div className="drawer-search-accordion">
            <div className="drawer-search-filter-col">
              <p className="drawer-search-text">Da</p>
              <VaporDatePicker
                format={dateFormatList}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(date) => {
                  setFilters("dateFrom", date);
                  if (date && filters.dateTo)
                    handleSearch();
  
                }}
                value={filters.dateFrom}
                disabledDate={(current) => {
                  if (!filters.dateTo) return false;
                  return current && current >= filters.dateTo;
                }}
                style={!filters.dateFrom && filters.dateTo ? { boxShadow: "0 0 0 2px red" } : {}}
              />
            </div>
            <div className="drawer-search-filter-col">
              <p className="drawer-search-text">A</p>
              <VaporDatePicker
                format={dateFormatList}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(date) => {
                  setFilters("dateTo", date);
                  if (filters.dateFrom && date)
                    handleSearch();
 
                }}
                disabledDate={(current) => {
                  if (!filters.dateFrom) return false;
                  return current && current <= filters.dateFrom;
                }}
                value={filters.dateTo}
                style={filters.dateFrom && !filters.dateTo ? { boxShadow: "0 0 0 2px red" } : {}}
              />
            </div>
          </div>
        </VaporAccordion>
        <VaporAccordion
          onChange={val => setAccordion([accordion[0], !accordion[1]])}
          opened={accordion[1]}
          title={<FormattedMessage id={"preCog.assetsTab.drawer.supplier"} />}
        >
          <div className="drawer-search-accordion">
            <div className="drawer-search-filter-col">
              <div className="drawer-search-text">
                <FormattedMessage id={"preCog.assetsTab.drawer.lookForSupplier"} />
              </div>
              <AutoComplete
                className="drawer-search-autocomplete longer"
                value={filters.supplier}
                onChange={(value) => {
                  setFilters("supplier", value);
                }}
              >
                <Search
                  size="large"
                  enterButton={
                    <FontAwesomeIcon icon={["fal", "search"]} />
                  }
                  onSearch={() => handleSearch()}
                />
              </AutoComplete>
            </div>
          </div>
        </VaporAccordion>
        {usedGoodsList && usedGoodsList.length > 0 &&
          <>
            <div className="drawer-search-filter-title">
              <FormattedMessage id={"preCog.assetsTab.drawer.results"} />
            </div>
            <Table
              rowSelection={{
                type: "radio",
                ...rowSelection
              }}
              columns={columns}
              dataSource={usedGoodsList}
            />
            {
              usedGoodsList.map(x => x.radiobutton)
            }
          </>}

      </div>
    </div>
  );
};

export default UsedGoodsSearch;
